import angular from 'angular';

angular
  .module('cxSettings')
  .controller('TaskTemplateRequiredAuthorizationsDialogCtrl', [
    '$filter',
    'flySvc',
    '$element',
    'close',
    'appUrls',
    '$http',
    'dialogsSvc',
    'taskTemplateId',
    'allAuthorizationsRequired',
    'requiredAuthorizations',
    taskTemplateRequiredAuthorizationsDialogCtrl,
  ]);

function taskTemplateRequiredAuthorizationsDialogCtrl(
  $filter,
  flySvc,
  $element,
  close,
  appUrls,
  $http,
  dialogsSvc,
  taskTemplateId,
  allAuthorizationsRequired,
  requiredAuthorizations,
) {
  var vm = this;
  vm.taskTemplateId = taskTemplateId;
  vm.saving = false;
  vm.requiredAuthorizations = [...requiredAuthorizations];
  vm.allAuthorizationsRequired = allAuthorizationsRequired;

  vm.delete = requiredAuthorization => {
    dialogsSvc
      .showYesNo('msgConfirmDeleteTitle', 'msgConfirmDeleteRequiredAuthorization')
      .then(function() {
        requiredAuthorization.deleting = true;
        return $http
          .delete(
            `${appUrls.tasks}/api/TaskTemplates/${taskTemplateId}/requiredauthorizations/${requiredAuthorization.id}`,
          )
          .then(
            () => {
              requiredAuthorization.deleting = false;
              var idx = vm.requiredAuthorizations.indexOf(requiredAuthorization);
              if (idx >= 0) vm.requiredAuthorizations.splice(idx, 1);
            },
            error => {
              flySvc.error(error);
              requiredAuthorization.deleting = false;
            },
          );
      });
  };

  vm.setAllAuthorizationsRequired = () => {
    return $http
      .put(
        `${appUrls.tasks}/api/TaskTemplates/${taskTemplateId}/allauthorizationsrequired/${vm.allAuthorizationsRequired}`,
      )
      .then(
        () => {},
        error => {
          flySvc.error(error);
        },
      );
  };

  vm.add = () => {
    vm.requiredAuthorizations.push({ authorizationType: undefined, isNew: true });
  };

  vm.save = function(requiredAuthorization) {
    if (
      requiredAuthorization.authorizationType === null ||
      requiredAuthorization.authorizationType === undefined
    )
      return;
    if (vm.saving) return;

    requiredAuthorization.saving = true;
    return $http
      .post(
        `${appUrls.tasks}/api/TaskTemplates/${taskTemplateId}/requiredauthorizations`,
        requiredAuthorization.authorizationType,
      )
      .then(
        ({ data }) => {
          flySvc.changesSaved();
          requiredAuthorization.saving = false;
          requiredAuthorization.isNew = false;
        },
        error => {
          flySvc.error(error);
          requiredAuthorization.saving = false;
        },
      );
  };

  vm.cancelNewAuthorization = requiredAuthorization => {
    var idx = vm.requiredAuthorizations.indexOf(requiredAuthorization);
    if (idx >= 0) vm.requiredAuthorizations.splice(idx, 1);
  };

  vm.cancel = function() {
    $element.modal('hide');
    close(
      {
        allAuthorizationsRequired: vm.allAuthorizationsRequired,
        requiredAuthorizations: vm.requiredAuthorizations.filter(x => !x.isNew),
      },
      500,
    );
  };
}
